module.exports = __webpack_public_path__ + "static/media/brand-trans.499f0ad6.png";